import { StoredAuthTokens } from '../interfaces/oauth';
import { calculateExpiresAtFromNow } from './time-utils';

/**
 * Parses a pasted OAuth token-response JSON (debug tooling) into storable tokens.
 * `expiresAt` is kept when present, otherwise derived from `expires_in`.
 * Returns null for invalid JSON or missing fields.
 */
export function parseTokenResponse(raw: string): StoredAuthTokens | null {
  try {
    const parsed = JSON.parse(raw.trim());
    if (
      typeof parsed?.access_token !== 'string' ||
      parsed.access_token.length === 0 ||
      typeof parsed.id_token !== 'string' ||
      parsed.id_token.length === 0 ||
      typeof parsed.refresh_token !== 'string' ||
      parsed.refresh_token.length === 0 ||
      typeof parsed.expires_in !== 'number'
    ) {
      return null;
    }
    return {
      access_token: parsed.access_token,
      id_token: parsed.id_token,
      refresh_token: parsed.refresh_token,
      expires_in: parsed.expires_in,
      expiresAt: typeof parsed.expiresAt === 'string' ? parsed.expiresAt : calculateExpiresAtFromNow(parsed.expires_in),
    };
  } catch {
    return null;
  }
}
